import {
  Button,
  ButtonGroup,
  Col,
  FormControl,
  FormGroup,
} from 'react-bootstrap'
import React, {FC, useContext, useEffect, useRef} from 'react'
import { Controller } from 'react-hook-form'
import { RootState } from '@store/store'
import { useSelector } from 'react-redux'
import { fetchSsmlById, selectSsmlById } from '@editor/store/slices/ssml.slice'
import { getSsmlLoading } from '@editor/store/selectors/ssml.selector'
import {
  EditorContext,
  EditorContextType,
} from '@editor/components/editorContext'
import XmlEditor from '@editor/components/misc/xmlEditor'
import { FaRedo, FaUndo } from 'react-icons/fa'
import { useHistory } from '@editor/components/misc/historyController'
import { useTheme } from '@config/themeContext'

const SsmlForm: FC = () => {
  const { job, dispatch, formMethods } = useContext(
    EditorContext
  ) as EditorContextType
  const { control, setValue } = formMethods
  const { recordChange, undo, redo, clearHistory, canUndo, canRedo } = useHistory()

  const ssmlLoading = useSelector(getSsmlLoading)
  const ssml = useSelector((state: RootState) =>
    job?.ssml ? selectSsmlById(state, job.ssml) : null
  )
  // Specifies that the change was done by redo or undo button, as the editor over reference would otherwise save again
  const ignoreChangeRef = useRef(false)
  const { theme } = useTheme()

  useEffect(() => {
    if (job && !ssmlLoading)
      dispatch(fetchSsmlById(job.ssml)).then(clearHistory)
  }, [job])

  useEffect(() => {
    if (ssml) {
      const formattedSsml = ssml.ssmlContent
        .replace(/(\r\n|\n|\r)/gm, '')
        .replace(/<[^>]*>/g, '\n$&')
        .replace('\n', '')
      setValue('ssmlArea', formattedSsml)
    }
  }, [ssml, setValue])

  const handleUndo = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault()
    const previousState = undo()
    if (previousState !== null) {
      ignoreChangeRef.current = true
      setValue('ssmlArea', previousState)
      ignoreChangeRef.current = false
    }
  }

  const handleRedo = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault()
    const nextState = redo()
    if (nextState !== null) {
      ignoreChangeRef.current = true
      setValue('ssmlArea', nextState)
      ignoreChangeRef.current = false
    }
  }

  const buttonStyle = (canAction: boolean) => ({
    color: canAction ? (theme === 'dark' ? 'white' : 'black') : 'inherit',
    opacity: canAction ? 1 : 0.3,
  })

  return (
    <Col>
      <FormGroup style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            zIndex: '100',
            maxWidth: 'fit-content',
            top: '-3.6rem',
            right: '1.5rem',
          }}
        >
          <ButtonGroup aria-label="Undo/Redo">
            <Button
              onClick={handleUndo}
              disabled={!canUndo()}
              variant="outline-secondary"
              style={buttonStyle(canUndo())}
            >
              <FaUndo />
            </Button>
            <Button
              onClick={handleRedo}
              disabled={!canRedo()}
              variant="outline-secondary"
              style={buttonStyle(canRedo())}
            >
              <FaRedo />
            </Button>
          </ButtonGroup>
        </div>
        <Controller
          name="ssmlArea"
          control={control}
          render={({ field }) => (
            <XmlEditor
              jobId={job?.id}
              value={field.value}
              onChange={(value: string) => {
                if (!ignoreChangeRef.current) {
                  recordChange(value)
                }
                field.onChange(value)
              }}
              id="ssmlFrom"
              placeholder="Ssml se vygeneruje zde"
              className="bg-light-subtle border-0"
              style={{ height: '60vh' }}
            />
          )}
        />
      </FormGroup>
    </Col>
  )
}
export default SsmlForm
